export default "__VITE_ASSET__BxiUXazg__"